import { render, staticRenderFns } from "./LevelView.vue?vue&type=template&id=9c478db4&"
import script from "./LevelView.vue?vue&type=script&lang=js&"
export * from "./LevelView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports